import Swiper from 'swiper';
import {Navigation, FreeMode} from 'swiper/modules';

export let timelineSwiper = new Swiper('.swiper-timeline', {
  modules: [Navigation, FreeMode],
  slidesPerView: 'auto',
  centerInsufficientSlides: true,
  loop: true,
  freeMode: {
    enabled: true
  },
  navigation: {
    nextEl: '.timeline-navigation .slide-next',
    prevEl: '.timeline-navigation .slide-prev',
  },
});

